import {
  ApiResponse,
  IDonViPdfExtra,
  IKeHoachSuaChuaResponseBase,
  PaginationResponseBase,
} from "@/core/interfaces/ApiResponses";
import { apiServiceInstance } from "@/core/helpers/utils";
import { IDanhSachKeHoachFilterParams } from "../interfaces/ApiRequest.interface";
import { formatDatePayload } from "@/core/hooks/use-date-time-hook";

export interface ICreateKeHoachNamRequest {
  so_van_ban: string;
  ngay_ban_hanh?: Date | null;
  ghi_chu: string;
  ten_ke_hoach: string;
  id_danh_muc_toa_xe: number;
  id_cap_sc: number;
  id_don_vi: number;
  so_luong_toa_xe: number;
  isCreating: boolean;
  id_ke_hoach?: number;
}

// Yearly maintenance plans: loai_ky=2, no thang, phan_loai defaults to 1 (chinh)
export class KeHoachNamService {
  static get(id: number): Promise<{
    data: ApiResponse<IKeHoachSuaChuaResponseBase>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      `/api/v1/ke-hoach-nam/chi-tiet/${id}`
    );
  }

  static async listAll(
    filters: Omit<IDanhSachKeHoachFilterParams, "current_page" | "per_page"> = {},
    per_page = 200
  ): Promise<{
    items: IKeHoachSuaChuaResponseBase[];
    extra?: IDonViPdfExtra;
  }> {
    const allItems: IKeHoachSuaChuaResponseBase[] = [];
    let page = 1;
    let total = Infinity;
    let extra: IDonViPdfExtra | undefined;

    while (allItems.length < total) {
      const { data: response } = await KeHoachNamService.list({
        ...filters,
        current_page: page,
        per_page,
      });
      const {
        data: { data, total: totalItems },
      } = response;

      if (page === 1) {
        extra = response.extra as IDonViPdfExtra | undefined;
      }

      total = totalItems;
      allItems.push(...data);

      if (!data.length) break;
      page += 1;
    }

    return { items: allItems, extra };
  }

  static list(
    {
      current_page,
      per_page,
      s,
      id_dm_toa_xe,
      id_don_vi,
    }: IDanhSachKeHoachFilterParams = {
      current_page: 1,
      per_page: 200,
      s: '',
      id_dm_toa_xe: 0,
    }
  ): Promise<{
    data: ApiResponse<PaginationResponseBase<IKeHoachSuaChuaResponseBase>>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      "/api/v1/ke-hoach-nam/danh-sach",
      {
        params: {
          ...(current_page && {
            page: current_page,
          }),
          ...(s && { s }),
          ...(id_dm_toa_xe && { id_dm_toa_xe }),
          ...(id_don_vi && { id_don_vi }),
        },
        headers: {
          ...(per_page && {
            perpage: per_page,
          }),
        },
      }
    );
  }

  static createOrUpdate({
    so_van_ban,
    ngay_ban_hanh,
    ghi_chu,
    ten_ke_hoach,
    id_danh_muc_toa_xe,
    id_cap_sc,
    id_don_vi,
    so_luong_toa_xe,
    isCreating,
    id_ke_hoach,
  }: ICreateKeHoachNamRequest): Promise<{
    data: ApiResponse<IKeHoachSuaChuaResponseBase>;
  }> {
    apiServiceInstance().vueInstance.axios.defaults.headers.common[
      "Content-Type"
    ] = "multipart/form-data";
    const bodyFormData = new FormData();
    bodyFormData.append("keHoach[so_van_ban]", so_van_ban);
    bodyFormData.append(
      "keHoach[ngay_ban_hanh]",
      ngay_ban_hanh ? formatDatePayload(ngay_ban_hanh) : ""
    );
    bodyFormData.append("keHoach[loai_ky]", "2");
    bodyFormData.append("keHoach[phan_loai]", "1");
    bodyFormData.append("keHoach[so_luong_toa_xe]", so_luong_toa_xe.toString());
    bodyFormData.append("keHoach[ghi_chu]", ghi_chu);
    bodyFormData.append("keHoach[ten_ke_hoach]", ten_ke_hoach);
    bodyFormData.append(
      "keHoach[id_danh_muc_toa_xe]",
      id_danh_muc_toa_xe.toString()
    );
    bodyFormData.append("keHoach[id_cap_sc]", id_cap_sc.toString());
    bodyFormData.append("keHoach[id_don_vi]", id_don_vi.toString());

    const URI = isCreating
      ? "/api/v1/ke-hoach-nam/tao-moi"
      : `/api/v1/ke-hoach-nam/cap-nhat/${id_ke_hoach}`;

    return apiServiceInstance().vueInstance.axios.post(URI, bodyFormData);
  }

  static delete(id: number) {
    return apiServiceInstance().vueInstance.axios.post(`/api/v1/ke-hoach-nam/xoa/${id}`);
  }
}
